import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // or "auto" if you want instant
    });
  }, [pathname]); // ✅ runs on route change

  return children || null;
};

export default ScrollTop;